/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultRowReorderColumnId = require("@inovua/reactdatagrid-community/normalizeColumns/defaultRowReorderColumnId");
var ICON_REORDER = _react.default.createElement("svg", {
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  style: {
    position: 'relative',
    top: 2,
    cursor: 'pointer'
  }
}, _react.default.createElement("g", {
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0L14 0 14 14 0 14z",
  transform: "translate(-3 -1)"
}), _react.default.createElement("path", {
  d: "M6.2 11.5c0 .825-.72 1.5-1.6 1.5-.88 0-1.6-.675-1.6-1.5S3.72 10 4.6 10c.88 0 1.6.675 1.6 1.5zm-1.6-6C3.72 5.5 3 6.175 3 7s.72 1.5 1.6 1.5c.88 0 1.6-.675 1.6-1.5s-.72-1.5-1.6-1.5zm0-4.5C3.72 1 3 1.675 3 2.5S3.72 4 4.6 4c.88 0 1.6-.675 1.6-1.5S5.48 1 4.6 1zm4.8 3c.88 0 1.6-.675 1.6-1.5S10.28 1 9.4 1c-.88 0-1.6.675-1.6 1.5S8.52 4 9.4 4zm0 1.5c-.88 0-1.6.675-1.6 1.5s.72 1.5 1.6 1.5c.88 0 1.6-.675 1.6-1.5s-.72-1.5-1.6-1.5zm0 4.5c-.88 0-1.6.675-1.6 1.5S8.52 13 9.4 13c.88 0 1.6-.675 1.6-1.5S10.28 10 9.4 10z",
  transform: "translate(-3 -1)"
})));
var _default = {
  id: _defaultRowReorderColumnId.id,
  headerAlign: 'center',
  textAlign: 'center',
  render: function render() {
    var className = 'InovuaReactDataGrid__row-reorder-icon';
    return _react.default.cloneElement(ICON_REORDER, {
      className: className
    });
  },
  cellSelectable: false,
  autoLock: true,
  header: '',
  showColumnMenuSortOptions: false,
  showColumnMenuGroupOptions: false,
  showColumnMenuTool: false,
  showInContextMenu: false,
  sortable: false,
  editable: false,
  resizable: false,
  draggable: false,
  groupBy: false,
  defaultWidth: 40,
  minWidth: 40
};
exports.default = _default;